import * as React from "react"
const SvgCheck = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m9.55 15.15 8.475-8.475q.3-.3.7-.3t.7.3.3.713q0 .412-.3.712l-9.175 9.2q-.3.3-.7.3a.96.96 0 0 1-.7-.3L4.55 13a.93.93 0 0 1-.288-.713 1.02 1.02 0 0 1 .313-.712q.3-.3.712-.3.413 0 .713.3z" />
  </svg>
)
export default SvgCheck
